import React from "react";

interface ProductErrorReportSubmittedProperties {
    readonly onClose: () => void;
}

export default function ProductErrorReportSubmitted({ onClose }: ProductErrorReportSubmittedProperties): React.JSX.Element {
    return (
        <div className="modal-body shop-body make-offer-body">
            <p className="fakeh3">Díky za spolupráci &#x1F44D;</p>
            <p>Co nejdříve to prověřím!</p>
            <div className="text-right shop-body-button">
                <button type="submit" className="btn btn-success" onClick={onClose}>Zavřít</button>
            </div>
        </div>
    );
}
